<template>
  <RxkDialog
    v-model="showInfo"
    width="480"
    title="退回"
    :is-loading="loading"
    @sure="handleSure"
    @close="handleClose"
  >
    <div class="tw-p-[16px]">
      <el-form ref="formRef" :rules="rules" :model="formState" label-position="top">
        <el-form-item label="选择退回类型" prop="remark">
          <RxkRadio v-model="formState.type" :list="radioList" />
        </el-form-item>
        <el-form-item label="选择退回节点" prop="nodeId" v-if="formState.type === '3'">
          <RxkSelect v-model="formState.nodeId" :list="nodeList" />
        </el-form-item>
        <el-form-item label="填写退回原因" prop="remark">
          <RxkInput v-model="formState.remark" show-word-limit type="textarea" maxlength="1000" />
        </el-form-item>
      </el-form>
    </div>
  </RxkDialog>
</template>
<script lang="ts" setup>
import { ref, computed, reactive, watch, nextTick } from 'vue'
import { RxkDialog } from '@/components/common/RxkDialog'
import { RxkInput, RxkRadio, RxkSelect } from '@/components/common'
import { AuthBtn } from '@/components/business/FlowDeal/config'

const props = defineProps({
  modelValue: Boolean,
  list: {
    type: Array,
    default: () => []
  }
})
const emit = defineEmits(['update:modelValue', 'submit'])

const showInfo = computed({
  get: () => {
    return props.modelValue
  },
  set: (val: any) => {
    emit('update:modelValue', val)
  }
})

const loading = ref(true)

function handleClose() {
  emit('update:modelValue', false)
}

// form相关
watch(
  () => props.modelValue,
  val => {
    if (val) {
      nextTick(() => {
        if (!formRef.value) return
        formRef.value.resetFields()
      })
    }
  }
)
const formState = reactive({
  type: '3',
  nodeId: '',
  remark: ''
})
const formRef = ref()
const rules = {
  remark: [{ required: true, message: '请填写退回原因', trigger: 'blur' }],
  type: [{ required: true, message: '请选择退回类型', trigger: 'change' }],
  nodeId: [{ required: true, message: '请选择退回节点', trigger: 'change' }]
}

const radioList = [
  // { label: '退回发起人', value: '1' },
  // { label: '退回上一个审批节点', value: '2' },
  { label: '退回指定节点', value: '3' }
]

const nodeList = computed(() => {
  return props.list
    ?.filter((el: any) => el.state === 'DONE' && el.type !== 'STRUCT')
    ?.map((el: any) => {
      return {
        label: el.name,
        value: el.guid
      }
    })
})

async function handleSure(fn: Fn = () => {}) {
  if (!formRef.value) return
  await formRef.value.validate(async (valid: any) => {
    if (valid) {
      emit('submit', {
        comment: formState.remark,
        action: AuthBtn.ROLLBACK,
        nodeGuid: formState.nodeId
      })
      handleClose()
      fn()
    } else {
      fn()
    }
  })
}
</script>
